import en from "./en.json";
import it from "./it.json";

const cusHomePage = { en, it };

export default cusHomePage;
